import { Component } from '@angular/core'

import { BaseComponent } from '../shared'

@Component({
    templateUrl: './in-progress.component.html',
    standalone: true,
})
export class InProgressComponent extends BaseComponent {}
